import { render, staticRenderFns } from "./ChannelList.vue?vue&type=template&id=cb1aea0c&scoped=true"
import script from "./ChannelList.vue?vue&type=script&lang=ts"
export * from "./ChannelList.vue?vue&type=script&lang=ts"
import style0 from "./ChannelList.vue?vue&type=style&index=0&id=cb1aea0c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1aea0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb1aea0c')) {
      api.createRecord('cb1aea0c', component.options)
    } else {
      api.reload('cb1aea0c', component.options)
    }
    module.hot.accept("./ChannelList.vue?vue&type=template&id=cb1aea0c&scoped=true", function () {
      api.rerender('cb1aea0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChannelList.vue"
export default component.exports